import { render } from "./loanClients.vue?vue&type=template&id=8698f560&scoped=true"
import script from "./loanClients.vue?vue&type=script&lang=js"
export * from "./loanClients.vue?vue&type=script&lang=js"

import "./loanClients.vue?vue&type=style&index=0&id=8698f560&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8698f560"]])

export default __exports__